// export const API_URL = 'https://ramapharma-api-mirror.beetronix.com/api'
// export const API_URL = 'https://mirror-api.octopharma.net/api'
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'
export const API_URL = 'https://api.goldenpharma.octopharma.net/api'
export const VERSION = '2.4.3'
